import { navigate } from "gatsby"

export const SignOut = async ( firebase, setUser, setAuthUser ) => {
  try {
    await firebase
      .auth()
      .signOut()

    localStorage.setItem( "isLoggedIn", false )
    setAuthUser( null )
    setUser( null )

    navigate( "/" )
  }
  catch ( error ) {
    console.log( "sign-out", { error } )
  }
}

export default SignOut